import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';
import { StaffDtoSchema } from '../contracts';

export enum GetStaffReviewStatusEnumDto {
  Overdue = 'overdue',
  DueSoon = 'dueSoon',
  NotDueYet = 'notDueYet',
}

const GetStaffResponseDtoSchema =
  PagePaginationResponseDtoSchema(StaffDtoSchema);

export type GetStaffRequestDto = PagePaginationRequestDto<
  {
    facilitiesIds?: number[];
    search?: string | null;
    minWageRate?: number | null;
    maxWageRate?: number | null;
    minDaysSinceLastReview?: number | null;
    reviewStatus?: GetStaffReviewStatusEnumDto[] | null;
  },
  | 'facilityName'
  | 'staffName'
  | 'jobRole'
  | 'wageRate'
  | 'hireDate'
  | 'daysSinceLastReview'
>;
export type GetStaffResponseDto = z.infer<typeof GetStaffResponseDtoSchema>;

export const getStaff = (
  params: GetStaffRequestDto,
  config?: AxiosRequestConfig<GetStaffRequestDto>
) => {
  const transformedParams: GetStaffRequestDto = {
    ...params,
    search: params.search?.trim() ? params.search.trim() : null,
  };

  return api
    .get('/staff', {
      params: transformedParams,
      ...config,
    })
    .then(responseContract(GetStaffResponseDtoSchema));
};
